export default function PageTitle({ title }) {
  return (
    <div className="max-w-screen-2xl mx-auto mb-6">
      <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>
    </div>
  )
}
